export default __webpack_public_path__ + "c627e7386b2797f89bef0debd46d9206.svg";